import { apiInstance } from "shared/api";
import { CompaniesResponse, BindCompaniesResponse } from "./types";

export const getCompanies = (key: string): Promise<CompaniesResponse> => {
  return apiInstance
    .get(`/v1/companies/${key}`)
    .then((response) => response.data);
};

export const bindCompanies = (key: string): Promise<BindCompaniesResponse> => {
  return apiInstance
    .patch(`/v1/companies/${key}/bind`)
    .then((response) => response.data);
};
